import { BaseBadge, Card } from '@/lib';
import { LegendItem } from '@/lib/Charts/common';
import { PerformanceAudienceKpi } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { KpiConfig } from '../PerformanceAudienceKpiRow/kpiConfig';

type DashboardKpiCardProps = {
  kpi: PerformanceAudienceKpi;
  titleKey: KpiConfig['titleKey'];
  subtitleKey: KpiConfig['subtitleKey'];
  badgeKey?: KpiConfig['badgeKey'];
  className?: string;
};

export const DashboardKpiCard: FC<DashboardKpiCardProps> = ({ kpi, titleKey, subtitleKey, badgeKey, className }) => {
  const { t } = useTranslation('performanceAudience');

  const breakdown = kpi.breakdown;

  return (
    <Card className={twMerge('flex min-h-[9.5rem] flex-col gap-3 border-primary-border bg-white p-5 drop-shadow-none', className)}>
      <div className='flex items-start justify-between gap-2'>
        <p className='text-sm font-semibold text-primary-900'>{t(titleKey)}</p>
        {kpi.badge === 'meta_only' && badgeKey ? (
          <BaseBadge className='bg-gray-100 text-[10px] font-semibold uppercase tracking-[0.08em] text-gray-600'>
            {t(badgeKey)}
          </BaseBadge>
        ) : null}
      </div>
      <p className='text-3xl font-semibold leading-tight text-primary-900'>{kpi.value}</p>
      <p className='text-xs text-tertiary-600'>{t(subtitleKey)}</p>
      {breakdown ? (
        <div className='mt-auto flex flex-wrap gap-4 pt-1 [&_p]:text-xs'>
          <LegendItem color='var(--brand-600)' name={`${breakdown.googleLabel} ${breakdown.googleValue}`} />
          <LegendItem color='var(--gray-600)' name={`${breakdown.metaLabel} ${breakdown.metaValue}`} />
        </div>
      ) : null}
    </Card>
  );
};
